import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const pushSupported = () => typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

const base64ToBytes = (value) => {
  const pad = '='.repeat((4 - (value.length % 4)) % 4);
  const raw = atob((value + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

const registration = async () => {
  const reg = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;
  return reg;
};

// Is THIS browser currently subscribed?
export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration('/sw.js');
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

// Must be called from a click handler (permission prompt).
export async function enablePush(authCfg) {
  if (!pushSupported()) throw new Error('This browser does not support push notifications. On iPhone, add the site to your Home Screen first.');
  const { data } = await axios.get(`${API}/push/public-key`, authCfg);
  const reg = await registration();
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notifications were blocked. Allow them in your browser settings and try again.');
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: base64ToBytes(data.publicKey) });
  }
  await axios.post(`${API}/push/subscribe`, { ...sub.toJSON(), device: navigator.userAgent.slice(0, 120) }, authCfg);
  return sub;
}

export async function disablePush(authCfg) {
  const sub = await currentSubscription();
  if (!sub) return;
  const endpoint = sub.endpoint;
  await sub.unsubscribe();
  await axios.delete(`${API}/push/subscribe`, { ...authCfg, params: { endpoint } });
}

export const sendTestPush = (authCfg) => axios.post(`${API}/push/test`, {}, authCfg);
